<div class="modal-body">
  <div class="modal-text-wrapper">
    <p class="title">{{ title }}</p>
    <p class="message">{{information}}</p>
  </div>
  <button type="button" class="modal-btn-primary" (click)="activeModal.close('')">{{positiveButton}}</button>
  <button type="button" class="modal-btn-secondary" (click)="activeModal.dismiss('')">{{negativeButton}}</button>
</div>
